import { useState, type ReactNode } from 'react';
import type { PillKind, ToastFn } from '../../types/integrations';
import { copyText } from '../../util/functions/UniversalFunctions';

const KIND_CLS: Record<PillKind, string> = {
  good: 'bg-emerald-100 text-emerald-700',
  warn: 'bg-amber-100 text-amber-700',
  bad: 'bg-red-100 text-red-700',
  muted: 'bg-slate-100 text-slate-600',
};

interface StatusPillProps {
  kind?: PillKind;
  children: ReactNode;
}

export default function StatusPill({ kind = 'muted', children }: StatusPillProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${KIND_CLS[kind]}`}
    >
      {children}
    </span>
  );
}

interface CopyRowProps {
  label: string;
  value: string;
  secret?: boolean;
  toast: ToastFn;
}

export function CopyRow({ label, value, secret, toast }: CopyRowProps) {
  const [shown, setShown] = useState(!secret);

  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-sm font-medium text-slate-700">{label}</span>
      <div className="flex items-center gap-2">
        <code className="flex-1 bg-slate-100 rounded-lg px-3 py-2 text-sm font-mono text-slate-800 overflow-x-auto whitespace-nowrap">
          {shown ? value : '•'.repeat(24)}
        </code>
        {secret && (
          <button
            type="button"
            className="px-3 py-2 text-sm rounded-lg border border-slate-300 hover:bg-slate-50 text-slate-700"
            onClick={() => setShown((s) => !s)}
          >
            {shown ? 'Hide' : 'Show'}
          </button>
        )}
        <button
          type="button"
          className="px-3 py-2 text-sm rounded-lg bg-blue-600 text-white hover:bg-blue-700"
          onClick={async () =>
            toast((await copyText(value)) ? 'Copied' : 'Copy failed', 'good')
          }
        >
          Copy
        </button>
      </div>
    </div>
  );
}